'use client';

import clsx from 'clsx';
import Link from 'next/link';
import FooterMenuItem from './footer-menu-item';

const FooterMenu = () => {
  return (
    <div className='lg_flex lg_flex-wrap lg_items-start lg_gap-x-[103px] lg_gap-y-5'>
      {configs.map(({ label, children }, i) => {
        return (
          <FooterMenuItem
            key={i}
            label={label}
            dropdown={
              <ul
                className={clsx(
                  'flex flex-col gap-y-[14px] lg_mt-[22px] lg_gap-y-2.5',
                  'py-[15px] pl-[30px] lg_py-0 lg_pl-0',
                  'border-b-1 border-solid border-E7DED5 lg_border-b-[0]',
                )}
              >
                {Array.isArray(children) && children.length > 0
                  ? children.map(({ label, href }, i) => {
                      return (
                        <li key={i}>
                          <Link
                            href={href}
                            className='text-[15px] leading-[22px] text-#403732 lg_hover_underline'
                          >
                            {label}
                          </Link>
                        </li>
                      );
                    })
                  : null}
              </ul>
            }
          />
        );
      })}
    </div>
  );
};

const configs = [
  {
    label: 'ABOUT US',
    children: [
      {
        label: 'About AW.Bridal',
        href: '/about-us',
      },
      {
        label: 'AW.Bridal Blog',
        href: 'https://www.awbridal.ca/wedding-blog/',
      },
      {
        label: 'Craftsmanship',
        href: '/craftsmanship',
      },
      {
        label: 'Real Wedding',
        href: '/real-wedding',
      },
      {
        label: 'Reviews',
        href: '/reviews',
      },
      {
        label: 'Sitemap',
        href: '/sitemap',
      },
    ],
  },
  {
    label: 'CUSTOMER CARE',
    children: [
      {
        label: 'Contact Us',
        href: '/contact-us',
      },
      {
        label: 'Help & FAQs',
        href: '/faq',
      },
      {
        label: 'Size Charts',
        href: '/size-chart',
      },
      {
        label: 'Shop By Color',
        href: '/shop-by-color',
      },
      {
        label: 'Track Your Order',
        href: '/track-your-order-login',
      },
      {
        label: 'Shipping Policy',
        href: '/shipping-policy',
      },
      {
        label: 'Return Policy',
        href: '/return-policy',
      },
      {
        label: 'Payment Method',
        href: '/payment-method',
      },
    ],
  },
  {
    label: 'SERVICES',
    children: [
      {
        label: '12% Student Discount',
        href: '/student-discount',
      },
      {
        label: '12% Nurse Discount',
        href: '/nurse-discount',
      },
      {
        label: 'Influencer Program',
        href: '/influencer-program',
      },
      {
        label: 'Affiliate Program',
        href: '/affiliate',
      },
      {
        label: 'Wholesale Program',
        href: '/wholesale-program',
      },
      {
        label: 'Wedding Planning',
        href: '/wedding-planners-pro',
      },
      {
        label: 'Virtual Appointments',
        href: '/virtual-appointments',
      },
      {
        label: 'Product Tester',
        href: '/recruit-free-product-tester',
      },
    ],
  },
  {
    label: 'SHOP BY CATEGORY',
    children: [
      {
        label: 'Wedding Dresses',
        href: '/wedding-dresses',
      },
      {
        label: 'Bridesmaid Dresses',
        href: '/bridesmaid-dresses',
      },
      {
        label: 'Wedding Guest',
        href: '/wedding-guest-dresses',
      },
      {
        label: 'Mother of Bride Dresses',
        href: '/mother-of-the-bride-dresses',
      },
      {
        label: 'Dresses',
        href: '/dresses',
      },
    ],
  },
];

export default FooterMenu;
